<template>
  <div id="app">
    <router-view/>
    <footer>Inkless<i class="copyright outline icon"></i> {{ new Date().getFullYear() }} v1.0 | Todos os direitos reservados</footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue